"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.endsWith = void 0;
function endsWith(src, second, equalityComparer) {
    const srcArr = [...src];
    const secondArr = Array.isArray(second) ? second : [...second];
    if (secondArr.length > srcArr.length) {
        return false;
    }
    for (let i = srcArr.length - secondArr.length, j = 0; i < srcArr.length; i++, j++) {
        const srcItem = srcArr[i];
        const secondItem = secondArr[j];
        if (equalityComparer) {
            if (!equalityComparer(srcItem, secondItem)) {
                return false;
            }
        }
        else {
            if (srcItem !== secondItem) {
                return false;
            }
        }
    }
    return true;
}
exports.endsWith = endsWith;
//# sourceMappingURL=endsWith.js.map